import { createActions } from 'redux-actions';
import { Claim } from '@models/Claim';
import { UpdateClaimParams } from '@apis/ClaimApi';

export type State = {
  claim?: Claim | null;
  status: string;
  note: string;
  totalClaimedAmount: number;
};

export type UserClaimUpdatePayload = UpdateClaimParams;
export type StateUpdatePayload = Partial<State>;

export const { userClaimFetch, userClaimUpdate, stateUpdate } = createActions(
  'USER_CLAIM_FETCH',
  'USER_CLAIM_UPDATE',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CLAIM_EDIT',
  },
);
